import React, { useRef, useState } from "react";
import classes from "./sideBarMenu.module.css";
import PropTypes from "prop-types";
import {
  coachDemoImg as Profile,
  HomeFilled,
  Homeoutlined,
  Notificationoutlined,
  NotificationFilled,
  ScheduleFilled,
  ScheduleOutlined,
  ChatOutlined,
  ChatFilled,
  ReviewFilled,
  ReviewOutlined,
  InsightsFilled,
  InsightsOutlined,
  ShortLogo,
  //
  EditLessonInfoIconBlack,
  EditProfileBlackIcon,
  HelpIconBlack,
  logoutIcon,
  SettingsIconBlack,
} from "../../constant/imagePath";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import { Overlay, OverlayTrigger, Tooltip } from "react-bootstrap";
import { MenuWithIcons } from "../MenuWithIcons/MenuWithIcons";
import { ReactSVG } from "react-svg";
import { useHistory, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setActiveTab } from "../../store/Actions/commonAction";

export const SideBarMenu = ({
  profile,
  logo,
  items,
  menuItems,
  setter,
  state,
  customStyle,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [isHover, setIsHover] = useState();
  const [showOverlay, setShowOverlay] = useState(false);
  const target = useRef(null);

  const menuOptions = [
    {
      icon: HelpIconBlack,
      label: "Help",
      onClick: () => history.push("/help"),
    },
    {
      icon: EditProfileBlackIcon,
      label: "Edit Profile",
      onClick: () => {
        dispatch(setActiveTab("personal-info"));
        history.push("/edit-profile");
      },
    },
    {
      icon: EditLessonInfoIconBlack,
      label: "Edit Lesson Info",
      onClick: () => {
        dispatch(setActiveTab("basic-info"));
        history.push("/edit-lesson-info");
      },
    },
    {
      icon: SettingsIconBlack,
      label: "Settings",
      onClick: () => {
        dispatch(setActiveTab("privacy-settings"));
        history.push("/profile-settings");
      },
    },
    { icon: logoutIcon, label: "Log out", onClick: "" },
  ];

  return (
    <>
      <style jsx>{`
        .sideBarMenu_overlay__KPetF {
        }
        .${classes.links} .${classes.listItem}:hover .${classes.icon} path {
          fill: #ffffff;
          stroke: #ffffff;
        }
        .${classes.links} .${classes.listItem}:hover .${classes.icon} rect {
          fill: #ffffff;
        }
        .${classes.links} .${classes.listItem}:hover .${classes.icon} circle {
          fill: #222222;
        }
        .${classes.links}
          .${classes.listItem}:hover
          .${classes.icon}
          path[stroke-linejoin="round"] {
          stroke: #222222;
        }
      `}</style>
      <div
        className={`${[classes.container].join(" ")}`}
        style={{ ...customStyle }}
      >
        <div className={`${[classes.headerSection].join(" ")}`}>
          <div className={`${[classes.logoBox].join(" ")}`}>
            <img src={logo} />
          </div>
          <ul className={`${[classes.links].join(" ")}`}>
            {items?.map((item, index) => {
              return (
                <li
                  className={`${[
                    classes.listItem,
                    state === item?.activeText && classes.selectedListItem,
                  ].join(" ")}`}
                  onMouseOver={() => setIsHover(index)}
                  onMouseLeave={() => setIsHover("")}
                  onClick={setter ? setter : item?.onClick}
                >
                  <ReactSVG
                    src={
                      state === item?.activeText ? item?.hoverIcon : item?.icon
                    }
                    beforeInjection={(svg) => svg.classList.add(classes.icon)}
                    className={[
                      state === item?.activeText && classes.fillWhite,
                    ].join(" ")}
                  />

                  <p
                    style={{
                      ...Fonts.p4,
                      color: Colors.white,
                      fontFamily:
                        state === item?.activeText ? "inter-500" : "inter-400",
                      letterSpacing: "-2%",
                    }}
                  >
                    {item?.text}
                  </p>
                </li>
              );
            })}
          </ul>
        </div>
        <div className={`${[classes.footerSection].join(" ")}`}>
          {/*  */}

          <OverlayTrigger
            placement={"right"}
            show={showOverlay}
            trigger={["click"]}
            overlay={
              <div className={classes.overlay}>
                <MenuWithIcons
                  menuItems={menuItems ? menuItems : menuOptions}
                />
              </div>
            }
            delay={{ show: 100, hide: 100 }}
            onToggle={() => setShowOverlay(!showOverlay)}
          >
            <div className={`${[classes.profileImg].join(" ")}`}>
              <img src={profile} />
            </div>
          </OverlayTrigger>
        </div>
      </div>
    </>
  );
};

SideBarMenu.propTypes = {
  logo: PropTypes.string,
  items: PropTypes.object,
  profile: PropTypes.string,
  menuItems: PropTypes.array,
  setter: PropTypes.func,
  state: PropTypes.string,
};
SideBarMenu.defaultProps = {
  logo: ShortLogo,
  items: [
    {
      icon: Homeoutlined,
      hoverIcon: Homeoutlined,
      text: "Dashboard",
      onClick: () => {},
    },
    {
      icon: Notificationoutlined,
      hoverIcon: NotificationFilled,
      text: "Users",
      onClick: () => {},
    },
    {
      icon: ScheduleOutlined,
      hoverIcon: ScheduleFilled,
      text: "Complaints",
      onClick: () => {},
    },
    {
      icon: ChatOutlined,
      hoverIcon: ChatFilled,
      text: "Requests",
      onClick: () => {},
    },
    {
      icon: ReviewOutlined,
      hoverIcon: ReviewFilled,
      text: "Reviews",
      onClick: () => {},
    },
    {
      icon: InsightsOutlined,
      hoverIcon: InsightsFilled,
      text: "Messages",
      onClick: () => {},
    },
  ],
  profile: Profile,
  // menuItems: [
  //   { icon: HelpIconBlack, label: "Help", onClick: "" },
  //   {
  //     icon: EditProfileBlackIcon,
  //     label: "Edit Profile",
  //     // onClick: () => history.push("/edit-profile"),
  //   },
  //   {
  //     icon: EditLessonInfoIconBlack,
  //     label: "Edit Lesson Info",
  //     // onClick: () => history.push("/edit-lesson-info"),
  //   },
  //   {
  //     icon: SettingsIconBlack,
  //     label: "Settings",
  //     // onClick: () => history.push("/profile-settings"),
  //   },
  //   { icon: logoutIcon, label: "Log out", onClick: "" },
  // ],
};
